import { z } from '@harvestiq/zod';

import { InsureIQPolicyTypes } from '@harvestiq/constants';
import { dbAipSettingsSchema } from '../aip-settings/db-aip-settings';
import { lrpEndorsementSchema } from '../coverages/lrp-endorsement';
import { lgmEndorsementSchema } from '../coverages/lgm-endorsement';
import { policySchema } from '../policies/policy';
import { dbSigningAgentSchema } from '../agents/db-signing-agent';

export const pdfFillingData = z.object({
  type: z.nativeEnum(InsureIQPolicyTypes),
  policy: policySchema,
  signingAgent: dbSigningAgentSchema.optional(),
  agencyInfo: dbAipSettingsSchema.optional(),
  lgmEndorsement: lgmEndorsementSchema.optional(),
  lrpEndorsement: lrpEndorsementSchema.optional(),
});
export type PdfFillingData = z.infer<typeof pdfFillingData>;
